import React from 'react';
export function FinalCTASection() {
  return <section className="px-5 py-10 pb-24 max-w-[640px] mx-auto text-center" data-id="element-47">
      <h2 className="text-[clamp(22px,5vw,32px)] font-extrabold leading-tight" data-id="element-48">
        ¿Seguirás adivinando
        <br data-id="element-49" />o empezarás a saber?
      </h2>

      <p className="text-white text-[17px] my-3.5 mb-7" data-id="element-50">
        Una relación equivocada te cuesta mucho más que $17.
      </p>

      <a href="https://decidirconclaridad.com/checkouts/cn/hWNBUkgxufwmF4ZJiE9h80g6/es-us" target="_blank" rel="noopener noreferrer" className="block bg-[var(--red2)] text-white text-center py-4 px-6 rounded-xl font-bold text-[15px] tracking-wider max-w-[400px] mx-auto hover:bg-[#a82040] transition-colors" data-id="element-51">
        OBTENER MI RADAR INSTANTÁNEO POR $17 →
      </a>

      <p className="text-[var(--muted)] text-xs mt-3" data-id="element-52">
        🛡️ Garantía de 30 días · Acceso instantáneo
      </p>
    </section>;
}